import { render } from "./BsFloatInput.vue?vue&type=template&id=b84df588"
import script from "./BsFloatInput.vue?vue&type=script&lang=js"
export * from "./BsFloatInput.vue?vue&type=script&lang=js"
script.render = render

export default script